export default __webpack_public_path__ + "static/media/weather.b9d0aa68.png";